'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getByUser = getByUser;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { localStore } from '../../utils/localStorage';

var GET_BY_USER = 'lookme/activity/GET_BY_USER';
var GET_BY_USER_FAIL = 'lookme/activity/GET_BY_USER_FAIL';
var GET_BY_USER_SUCCESS = 'lookme/activity/GET_BY_USER_SUCCESS';
var initialState = {
  data: null,
  loadError: null,
  loaded: false,
  prominentLoaded: false,
  postCount: 0,
  media: [],
  activities: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GET_BY_USER:
      return (0, _extends3.default)({}, state, {
        gettingByUser: true
      });
    case GET_BY_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        activities: action.result.activities,
        gettingByUser: false
      });
    case GET_BY_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingByUser: false,
        gettingError: action.error,
        success: true
      });
    default:
      return state;
  }
}

function getByUser() {
  // const token = localStore().get('token');
  return {
    types: [GET_BY_USER, GET_BY_USER_SUCCESS, GET_BY_USER_FAIL],
    promise: function promise(client) {
      return client.get('/activity/load');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/activity.js
// module id = 366
// module chunks = 0